// extracted by mini-css-extract-plugin
module.exports = {"EmailListForm":"EmailListForm-module--EmailListForm--1lcS1","Wrapper":"EmailListForm-module--Wrapper--3g09_"};